import { OrderTotalsSummarySkeleton } from '@app/components/various/OrderTotalsSummary/OrderTotalsSummarySkeleton';
import { Skeleton } from '@app/components/various/Skeleton';

export const CheckoutSubtotalSkeleton = () => {
  return (
    <div className="w-full">
      <div className="mb-5 flex items-center justify-between">
        <h3 className="w-full max-w-44">
          <Skeleton type="text" size="xlarge" />
        </h3>
        <div className="w-14">
          <Skeleton type="text" size="large" />
        </div>
      </div>
      <OrderTotalsSummarySkeleton itemsAmount={5} />
    </div>
  );
};
